import React from "react";
import { Info } from "lucide-react";
import { PageHero, SectionLabel, Reveal, ArrowLink } from "../components/common";
import { CtaBand } from "./Home";
import { IMG, INVEST_THESIS, PRODUCT_FAMILIES } from "../mock";

export default function Investors() {
  return (
    <main>
      <PageHero
        index="07"
        eyebrow="A Garry Industries Ventures · Investors"
        title="A platform business, engineered for the long term."
        subtitle="Railway Machines combines the defensibility of heavy engineering with the scalability of digital platforms — across multiple product families and revenue layers."
        image={IMG.corpB}
      />

      {/* Thesis */}
      <section className="bg-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><SectionLabel>A Garry Industries Ventures · Investment Thesis</SectionLabel></Reveal>
          <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">Why the opportunity is compelling.</h2></Reveal>
          <div className="mt-16 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
            {INVEST_THESIS.map((t, i) => (
              <Reveal key={i} delay={(i % 3) * 70} className="group bg-[#0a0a0a] p-8 hover:bg-[#111] transition-colors">
                <div className="font-mono2 text-[#c3e63c] text-sm">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-display mt-4 text-xl font-semibold">{t.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-400">{t.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Product families */}
      <section className="bg-[#f2f1ec] text-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><SectionLabel light>A Garry Industries Ventures · Product Families</SectionLabel></Reveal>
          <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">Multiple platforms, one ecosystem.</h2></Reveal>
          <div className="mt-16 grid gap-px bg-[#d8d7d0] sm:grid-cols-2 lg:grid-cols-4">
            {PRODUCT_FAMILIES.map((f, i) => (
              <Reveal key={f.id} delay={i * 70} className="group bg-[#f2f1ec] p-8 hover:bg-white transition-colors">
                <div className="font-mono2 text-[#8ba817] text-sm">{f.id}</div>
                <h3 className="font-display mt-4 text-xl font-semibold">{f.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#4a4a44]">{f.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Engage */}
      <section className="relative overflow-hidden bg-[#0a0a0a] py-24 md:py-32">
        <img src={IMG.corpA} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/90 to-[#0a0a0a]/50" />
        <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr] lg:gap-20">
            <div>
              <Reveal><SectionLabel>A Garry Industries Ventures · Engage With Us</SectionLabel></Reveal>
              <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl font-bold leading-[1.03] tracking-tight">For investors and strategic partners.</h2></Reveal>
              <Reveal delay={100}><p className="mt-6 max-w-xl text-neutral-300 leading-relaxed">We welcome conversations with investors, strategic partners and institutions who share a long-term view of railway infrastructure. As a Garry Industries venture, reach out to explore how you can be part of building a globally respected railway machinery company.</p></Reveal>
              <div className="mt-9"><ArrowLink to="/contact">Contact investor relations</ArrowLink></div>
            </div>
            <Reveal delay={150} className="flex">
              <div className="border border-white/15 bg-[#0d0d0d]/80 p-7 backdrop-blur">
                <div className="flex items-center gap-2 eyebrow text-[#c3e63c]"><Info size={14} /> Note</div>
                <p className="mt-4 text-sm leading-relaxed text-neutral-400">This website presents Railway Machines' vision, engineering approach and platform strategy. It intentionally contains no fabricated financial data, customer logos or certifications. Detailed information is shared directly with qualified parties.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
